import axios from 'axios';
import { API_BASE } from '../config';

// Normalizza base URL; se manca /index.php lo aggiunge
const RAW = (API_BASE || `${window.location.origin}/server`).replace(/\/+$/, '');
const BASE = RAW.endsWith('/index.php') ? RAW : `${RAW}/index.php`;

const api = axios.create({
    baseURL: BASE,
    withCredentials: true, // cookie di sessione PHP
});

export default api;